import { SongData } from 'services/store/distribution/types';
import { StatusContainer, StatusCircle } from './styled';

type PropsType = {
  song: SongData;
};

const StatusSection = ({ song }: PropsType) => {
  const { status } = song;

  return (
    <StatusContainer>
      <StatusCircle status={status} />
    </StatusContainer>
  );
};

export default StatusSection;
